import { useAtomValue } from 'jotai/utils';
import { addonsSettingsAtom } from 'src/shared/settings/addons';
import { useSettingsQuery } from 'src/api/queries/userQueries';

/** True when the DELIVERY_INSIGHTS addon is granted AND enabled for the
 *  account. Calls useSettingsQuery so the addons atom hydrates on pages
 *  that don't otherwise load settings. */
export function useDeliveryInsightsEnabled(): boolean {
  useSettingsQuery();
  const addonsSettings = useAtomValue(addonsSettingsAtom);
  return Boolean(
    addonsSettings?.DELIVERY_INSIGHTS?.added &&
      addonsSettings?.DELIVERY_INSIGHTS?.enabled,
  );
}
